module.exports = __webpack_public_path__ + "img/inst-modal-15.4ad5ca2b.png";